var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "primary" } }),
      _vm.loading
        ? _c("c-loader", {
            attrs: { active: true, height: 450, label: "Данные загружаются" },
          })
        : [
            !_vm.tabs.length
              ? _c(
                  "div",
                  { staticClass: "no-tabs" },
                  [
                    _c("div", { staticClass: "mb-4 text" }, [
                      _vm._v("Анкета для этой должности не настроена"),
                    ]),
                    _c("c-button", {
                      attrs: { color: "primary", label: "Настройка анкеты" },
                      on: { click: _vm.toProfile },
                    }),
                  ],
                  1
                )
              : [
                  _vm.tabs.length > 1
                    ? _c(
                        "div",
                        { staticClass: "tabs" },
                        _vm._l(_vm.tabs, function (tab) {
                          return _c(
                            "button",
                            {
                              key: tab.id,
                              staticClass: "tab",
                              class: {
                                active: _vm.activeTabId === tab.id,
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.setTab(tab.id)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(tab.name) + " ")]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _c("profile-tab", {
                    attrs: {
                      "user-id": _vm.userId,
                      tab: _vm.activeTab,
                      "profile-data": _vm.profileData,
                      editable: _vm.editable,
                    },
                    on: {
                      update: _vm.updateProfileData,
                      changesCounter: function ($event) {
                        _vm.hasChanges = $event
                      },
                    },
                  }),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }